'use client';

import {
	PNL_MODAL_CARD_IMAGE_PATHS,
	PNL_MODAL_MAX_COLLATERAL_DISPLAY_COUNT,
} from 'src/components/Modals/PnlModal/consts';
import useBalanceAssetSymbolsByQuoteValueDesc from 'src/components/Modals/PnlModal/hooks/useBalanceAssetSymbolsByQuoteValueDesc';
import MarketIcon from 'src/components/Utils/MarketIcon';
import {
	VELOCITY_TEXT_LOGO_DARK_SRC,
	VELOCITY_TEXT_LOGO_LIGHT_SRC,
} from 'src/constants/constants';

const DISPLAY_NONE_STYLE = { display: 'none' };

/**
 * Renders PnL modal bg images, Velocity logos, and collateral icons with `display: none`
 * so they can be downloaded before the user opens the modal, reducing the likelihood
 * of them having to wait for the assets to load. Uses `style` rather than `className`
 * so it's not dependent on stylesheets.
 *
 * Note, only renders if `balanceAssetSymbolsByQuoteValueDesc` exists so as to minimize
 * extra time added to first load.
 */
export default function PnlModalAssetPreloader() {
	const balanceAssetSymbolsByQuoteValueDesc =
		useBalanceAssetSymbolsByQuoteValueDesc();

	if (!balanceAssetSymbolsByQuoteValueDesc) {
		return null;
	}

	return (
		<>
			{/* Bg images */}
			{PNL_MODAL_CARD_IMAGE_PATHS.map((path) => (
				<img style={DISPLAY_NONE_STYLE} key={path} src={path} alt="" />
			))}

			{/* Velocity logos */}
			<img
				style={DISPLAY_NONE_STYLE}
				src={VELOCITY_TEXT_LOGO_DARK_SRC}
				alt=""
			/>
			<img
				style={DISPLAY_NONE_STYLE}
				src={VELOCITY_TEXT_LOGO_LIGHT_SRC}
				alt=""
			/>

			{/* Collateral icons */}
			{balanceAssetSymbolsByQuoteValueDesc
				.slice(0, PNL_MODAL_MAX_COLLATERAL_DISPLAY_COUNT)
				.map((symbol) => (
					<MarketIcon
						style={DISPLAY_NONE_STYLE}
						key={symbol}
						marketSymbol={symbol}
						useNextApiRoute
					/>
				))}
		</>
	);
}
